module.exports = __webpack_public_path__ + "static/media/1.2dc49a6e.png";